import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../../shared';
import { ClientePipeSharedModule } from '../../../pipes';

import { ClienteCentralCompraParticipanteSelectComponent } from './cliente-central-compra-participante-select.component';

@NgModule({
    imports: [
        SharedModule,
        ClientePipeSharedModule
    ],
    declarations: [
        ClienteCentralCompraParticipanteSelectComponent
    ],
    exports: [
        ClienteCentralCompraParticipanteSelectComponent
    ]
})
export class ClienteCentralCompraParticipanteSelectModule { }
